import React from 'react';
import { motion } from 'framer-motion';
export function ClosingBlock() {
  return <section id="closing" className="w-full scroll-mt-20 bg-ink px-5 py-8 sm:py-16" data-id="element-77" data-mp="2fp3ggjfih1kl">
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-78" data-mp="2apqstwgtfqgy">
        <h2 className="font-serif-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-79" data-mp="1w0umq4ybkniz">
          Votre prochaine leçon n’a pas besoin de commencer par une page blanche.
        </h2>

        <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-white/80 sm:mt-6 sm:text-lg" data-id="element-80" data-mp="1n04ufb89pfa0">
          Vous avez déjà les connaissances et votre manière d’enseigner. CHIMIE VISUELLE™ vous apporte
          simplement une base déjà prête, que vous sélectionnez et adaptez selon vos classes.
        </p>

        <div className="mt-6 flex flex-col gap-2 text-[15px] font-medium text-white/90 sm:mt-8 sm:text-lg" data-id="element-81" data-mp="3ntps1gviua7b">
          <p data-id="element-82" data-mp="3skoaam02lid7">5 volumes pédagogiques + 4 ressources complémentaires</p>
          <p data-id="element-83" data-mp="3slze2ltimq4b">460 pages entièrement en français</p>
          <p className="text-cobalt" data-id="element-84" data-mp="3dwbcdjhf9pg2">
            Schémas · Fiches visuelles · Activités · Évaluations · Corrigés
          </p>
        </div>

        <p className="mt-8 font-serif-display text-xl font-bold text-white sm:mt-10 sm:text-2xl" data-id="element-85" data-mp="3is8ths0ieztw">
          Choisissez le thème. Ouvrez la ressource. Enseignez.
        </p>

        <div className="mt-6 flex flex-col items-center sm:mt-8" data-id="element-86" data-mp="fd4edmry2sxv">
          <span className="text-sm font-medium text-white/60 sm:text-base" data-id="element-87" data-mp="gvkl0qtp7su">Paiement unique</span>
          <span className="font-serif-display text-[52px] font-bold leading-none text-cobalt sm:text-7xl" data-id="element-88" data-mp="5ex9w3eue3cr">
            19 €
          </span>
        </div>

        <motion.a href="#get-access" animate={{
        y: [0, -2, 0],
        scale: [1, 1.015, 1]
      }} whileHover={{
        scale: 1.025,
        boxShadow: '0 16px 34px -10px rgba(22, 163, 74, 0.7)'
      }} whileTap={{
        scale: 0.98
      }} transition={{
        y: {
          duration: 2.2,
          ease: 'easeInOut',
          repeat: Infinity
        },
        scale: {
          duration: 2.2,
          ease: 'easeInOut',
          repeat: Infinity
        },
        type: 'spring',
        stiffness: 400,
        damping: 22
      }} className="mt-7 flex min-h-[54px] w-full max-w-md items-center justify-center gap-2 rounded-[10px] bg-cta-green px-6 py-4 text-center text-[15px] font-extrabold tracking-tight text-white shadow-lg shadow-cta-green/40 sm:mt-9 sm:min-h-[58px] sm:text-lg" data-id="element-89" data-mp="2l8p8ea4a8iso">
          COMMENCER AVEC CHIMIE VISUELLE™
        </motion.a>
        <p className="mt-3 text-[11px] text-white/60 sm:text-xs" data-id="element-90" data-mp="3v5450jhjzk0i">
          Paiement unique · Aucun abonnement · Accès numérique · Accès à vie
        </p>
      </motion.div>
    </section>;
}